var map = {
	"./facebook.png": "p8ve",
	"./font/Montserrat-Black.ttf": "1YRD",
	"./font/TUV-Montserrat-Bold.ttf": "9Jux",
	"./font/UTM-Erie-Black.ttf": "lWoS",
	"./font/UTM-Mabella.ttf": "o3wb",
	"./font/font.css": "NrZ4",
	"./icon-close.png": "p6I1",
	"./jump/bgi-btn.png": "/xku",
	"./jump/bgi-dialog.png": "BDdE",
	"./jump/bgi-form.png": "rUIr",
	"./jump/bgi-h5.jpg": "ugzP",
	"./jump/bgi-pc.jpg": "Ddo7",
	"./jump/bgi-tag-left-active.png": "OcVW",
	"./jump/bgi-tag-left.png": "DETP",
	"./jump/bgi-tag-right-active.png": "RZlV",
	"./jump/bgi-tag-right.png": "FLOZ",
	"./jump/eye-close.png": "Mrk/",
	"./jump/eye-open.png": "06rf",
	"./jump/icon-close.png": "TMsi",
	"./jump/icon-code.png": "+4ys",
	"./jump/icon-email.png": "rpZf",
	"./jump/icon-password.png": "eHm3",
	"./jump/icon-phone.png": "0CH/",
	"./jump/icon-username.png": "WYE9",
	"./jump/swiper-left.png": "Lf5e",
	"./jump/swiper/swiper-1.jpg": "+uCx",
	"./jump/swiper/swiper-2.jpg": "pcqw",
	"./jump/swiper/swiper-3.jpg": "bWU6",
	"./jump/swiper/swiper-4.jpg": "s7oN",
	"./jump/title.png": "sfFk",
	"./ldp/bg-h5.png": "dym9",
	"./ldp/bg.png": "3Y69",
	"./ldp/bg1.png": "+8U3",
	"./ldp/bg2.png": "1q6J",
	"./ldp/bg3.png": "QUaD",
	"./ldp/bg4.png": "Yfg1",
	"./ldp/closebtn.png": "HODe",
	"./ldp/end-title.png": "WoHD",
	"./ldp/eye-close.png": "8aZL",
	"./ldp/eye-open.png": "pj+X",
	"./ldp/form/icon-code.png": "EvlP",
	"./ldp/form/icon-passwd.png": "UjSj",
	"./ldp/form/icon-user.png": "Df5e",
	"./ldp/form/login-1.png": "mzRT",
	"./ldp/form/login-2.png": "b6rf",
	"./ldp/form/register-1.png": "yLlx",
	"./ldp/form/register-2.png": "QX4n",
	"./ldp/game-1.png": "lheM",
	"./ldp/game-2.png": "TyAq",
	"./ldp/game-3.png": "tkmL",
	"./ldp/game-4.png": "HMzI",
	"./ldp/game-5.png": "Fvts",
	"./ldp/h5btn.gif": "o0+6",
	"./ldp/login.gif": "oIuv",
	"./ldp/regist.gif": "4hx1",
	"./logo.png": "7Otq",
	"./new-sport/bgi-email.png": "gjd6",
	"./new-sport/bgi-form-h5.png": "D4no",
	"./new-sport/bgi-gorm.png": "Hqku",
	"./new-sport/bgi-h5.jpg": "lX2g",
	"./new-sport/bgi-pc.jpg": "mill",
	"./new-sport/bgi-phone.png": "MT4f",
	"./new-sport/bgi-pwd.png": "XtyZ",
	"./new-sport/bgi-user.png": "U9+g",
	"./new-sport/btn-login.gif": "nCw3",
	"./new-sport/btn-register.gif": "uSEO",
	"./new-sport/icon-1.png": "aoXN",
	"./new-sport/icon-2.png": "I7SW",
	"./new-sport/icon-3.png": "4rPr",
	"./new-sport/icon-4.png": "4WFQ",
	"./new-sport/icon-5.png": "W/02",
	"./new-sport/icon-6.png": "xHG/",
	"./new-sport/icon-close.png": "XX6M",
	"./new-sport/icon-fb.png": "K/K4",
	"./new-sport/icon-l.png": "nAI9",
	"./new-sport/icon-login-a.png": "RPx5",
	"./new-sport/icon-login-n.png": "mjuq",
	"./new-sport/icon-r.png": "MgXx",
	"./new-sport/icon-reg-a.png": "KSLH",
	"./new-sport/icon-reg-n.png": "7vgK",
	"./new-sport/icon-tg.png": "AW7k",
	"./new-sport/main-register.gif": "WBJp",
	"./new-sport/success-login-h5.png": "GeVb",
	"./new-sport/success-login.png": "xZCB",
	"./new-sport/success-reg-h5.png": "upB4",
	"./new-sport/success-reg.png": "Yl8G",
	"./road/bgi-btn-active.png": "XVwg",
	"./road/bgi-btn-normal.png": "uBzu",
	"./road/bgi-btn-submit.png": "qwLw",
	"./road/bgi-dialog-h5.png": "+Jrp",
	"./road/bgi-dialog-pc.png": "WDcB",
	"./road/bgi-h5.jpg": "/z0R",
	"./road/bgi-input.png": "0qZ8",
	"./road/bgi-message.png": "A8OC",
	"./road/bgi-pc.jpg": "ss9A",
	"./road/icon-email.png": "rfCd",
	"./road/icon-password.png": "//NM",
	"./road/icon-phone.png": "DVW3",
	"./road/icon-success.png": "d19U",
	"./road/icon-username.png": "/+Vt",
	"./road/logo.png": "ph1m",
	"./road/title.png": "z8t6",
	"./sport/bgi-dialog.png": "HRUs",
	"./sport/bgi-form.png": "Op1d",
	"./sport/bgi-h5.jpg": "+7KZ",
	"./sport/bgi-input.png": "dsok",
	"./sport/bgi-pc.jpg": "H3Vr",
	"./sport/btn-login.png": "WdUv",
	"./sport/btn-register.png": "xgbq",
	"./sport/icon-email.png": "Vd+V",
	"./sport/icon-fb.png": "NvwI",
	"./sport/icon-password.png": "F0Xg",
	"./sport/icon-phone.png": "LyPF",
	"./sport/icon-tg.png": "btIk",
	"./sport/icon-username.png": "4Wei",
	"./sport/loading.gif": "EQQn",
	"./sport/tag-login.png": "Us2E",
	"./sport/tag-regist.png": "k40h",
	"./sport/title.png": "ve7A",
	"./sport3/bgi-dialog.png": "Tgtq",
	"./sport3/bgi-form.png": "Z0Zo",
	"./sport3/bgi-h5.jpg": "Uitw",
	"./sport3/bgi-input.png": "ueap",
	"./sport3/bgi-pc.jpg": "T8Oo",
	"./sport3/btn-login.png": "vX9w",
	"./sport3/btn-register.png": "D5Rc",
	"./sport3/icon-email.png": "E9ek",
	"./sport3/icon-fb.png": "p07M",
	"./sport3/icon-password.png": "kNUW",
	"./sport3/icon-phone.png": "JLde",
	"./sport3/icon-tg.png": "/dBP",
	"./sport3/icon-username.png": "MRBe",
	"./sport3/loading.gif": "vOM9",
	"./sport3/tag-login.png": "2s1T",
	"./sport3/tag-regist.png": "rz3M",
	"./sport3/title.png": "+eic",
	"./sport4/bgi-dialog.png": "bcPw",
	"./sport4/bgi-form.png": "NbZR",
	"./sport4/bgi-h5.jpg": "1SK2",
	"./sport4/bgi-input.png": "I9Zm",
	"./sport4/bgi-pc.jpg": "wqC/",
	"./sport4/btn-login.png": "o6Ig",
	"./sport4/btn-register.png": "5yxg",
	"./sport4/icon-email.png": "EpwQ",
	"./sport4/icon-fb.png": "wuG/",
	"./sport4/icon-password.png": "iKUx",
	"./sport4/icon-phone.png": "SueM",
	"./sport4/icon-tg.png": "kdOD",
	"./sport4/icon-username.png": "IoEo",
	"./sport4/loading.gif": "VRls",
	"./sport4/logo.png": "mlOo",
	"./sport4/swiper-1.png": "nY4q",
	"./sport4/swiper-2.png": "9l4U",
	"./sport4/swiper-3.png": "XMi7",
	"./sport4/swiper-4.png": "6WKB",
	"./sport4/tag-login.png": "er09",
	"./sport4/tag-regist.png": "c26H",
	"./sport4/title.png": "RF4A",
	"./sport5/bgi-form-login.png": "7J2L",
	"./sport5/bgi-form.png": "cVph",
	"./sport5/bgi-h5.png": "Hi2X",
	"./sport5/bgi-input.png": "v76d",
	"./sport5/bgi-pc.png": "5ok3",
	"./sport5/btn-login.png": "ZmLu",
	"./sport5/btn-register.png": "6+P1",
	"./sport5/close-dialog.png": "78V8",
	"./sport5/dang-ky-nhan.png": "k1fy",
	"./sport5/facebook.png": "qYMw",
	"./sport5/game-bottom.png": "PgWw",
	"./sport5/login-success-new.png": "G/n9",
	"./sport5/login-success.png": "Ksrj",
	"./sport5/logo-title.png": "p/PV",
	"./sport5/middle-center.png": "1D7e",
	"./sport5/register-success-new.png": "Iuqj",
	"./sport5/register-success.png": "TXb0",
	"./sport5/swiper-1.png": "BvaE",
	"./sport5/swiper-2.png": "ZQ6n",
	"./sport5/swiper-3.png": "R9ss",
	"./sport5/swiper-4.png": "9T50",
	"./sport5/tag-login-active.png": "sLri",
	"./sport5/tag-login.png": "bgwC",
	"./sport5/tag-regist-active.png": "Qb1a",
	"./sport5/tag-regist.png": "GXAM",
	"./sport5/telegram.png": "JhaX",
	"./sport6/arrow.png": "phYH",
	"./sport6/bg-h5.jpg": "YKLF",
	"./sport6/bg.jpg": "XGvb",
	"./sport6/facebook.png": "fBG5",
	"./sport6/form/check.png": "rDxJ",
	"./sport6/form/form-bg.png": "PfoZ",
	"./sport6/form/lock.png": "Ieng",
	"./sport6/form/login-1.png": "QKo1",
	"./sport6/form/login-2.png": "z7zQ",
	"./sport6/form/register-1.png": "cJ7e",
	"./sport6/form/register-2.png": "EhdE",
	"./sport6/form/safe.png": "x23S",
	"./sport6/game-1.png": "Bbd2",
	"./sport6/game-2.png": "49O3",
	"./sport6/game-3.png": "68DE",
	"./sport6/game-4.png": "IuDr",
	"./sport6/game.png": "zb8m",
	"./sport6/icon-1.png": "uKGT",
	"./sport6/icon-2.png": "8sy4",
	"./sport6/icon-3.png": "Jesp",
	"./sport6/icon.png": "ei3M",
	"./sport6/login.gif": "J9/x",
	"./sport6/logo.png": "Boj1",
	"./sport6/regist.gif": "BCH8",
	"./sport6/success.png": "4UBp",
	"./sport6/telegram.png": "0LbC",
	"./sport6/title.png": "hNZi",
	"./sport7/bg-h5.png": "UCoM",
	"./sport7/bg.jpg": "t27e",
	"./sport7/bg.png": "HDIy",
	"./sport7/bgi-dialog.png": "nZyb",
	"./sport7/btn-next.svg": "wh9J",
	"./sport7/btn-prev.svg": "T7j7",
	"./sport7/euro.gif": "1cCA",
	"./sport7/facebook.png": "9m54",
	"./sport7/form-pc/form-bg-1.png": "crsa",
	"./sport7/form-pc/form-bg.png": "5yO/",
	"./sport7/form/form-bg-1.png": "S2ok",
	"./sport7/form/form-bg.png": "vVEq",
	"./sport7/form/icon-code.png": "28ue",
	"./sport7/form/icon-eye.png": "fKtK",
	"./sport7/form/icon-ieye.png": "1GDr",
	"./sport7/form/icon-passwd.png": "D+dY",
	"./sport7/form/icon-phone.png": "0iTC",
	"./sport7/form/icon-user.png": "KnCu",
	"./sport7/form/login-1.png": "LAKf",
	"./sport7/form/login-2.png": "JBiA",
	"./sport7/form/register-1.png": "lmOw",
	"./sport7/form/register-2.png": "u66R",
	"./sport7/game-1.png": "P26U",
	"./sport7/game-2.png": "w9gM",
	"./sport7/game-3.png": "X5D+",
	"./sport7/game-4.png": "M9pG",
	"./sport7/game-5.png": "skq/",
	"./sport7/login.gif": "8Vu/",
	"./sport7/logo.png": "wAE1",
	"./sport7/regist.gif": "aUmv",
	"./sport7/register-success-new.png": "X6H5",
	"./sport7/success.png": "K8Az",
	"./sport7/telegram.png": "dMzM",
	"./sport7/title-pc.png": "KAi6",
	"./sport7/title.png": "kT7F",
	"./svg/email.svg": "ULWC",
	"./svg/mobile.svg": "sxKw",
	"./svg/password.svg": "Jtj/",
	"./svg/user.svg": "fP5l",
	"./telegram.png": "Rplw",
	"./trea/bgi-btn-reg.png": "Hev4",
	"./trea/bgi-dialog.png": "felI",
	"./trea/bgi-form.png": "GruS",
	"./trea/bgi-h5.jpg": "tfNC",
	"./trea/bgi-login-active.png": "tL1v",
	"./trea/bgi-login-btn.png": "dtyl",
	"./trea/bgi-login-normal.png": "iSEt",
	"./trea/bgi-reg-active.png": "z482",
	"./trea/bgi-reg-normal.png": "23CA",
	"./trea/bgi-swiper.png": "Hnog",
	"./trea/bgi.jpg": "wdL5",
	"./trea/captain.png": "F0vm",
	"./trea/icon-close.png": "NwiD",
	"./trea/icon-email.png": "eaIa",
	"./trea/icon-password.png": "b7EA",
	"./trea/icon-phone.png": "TTWp",
	"./trea/icon-user.png": "enPz",
	"./trea/logo.png": "PkpH",
	"./trea/slide1.png": "3twk",
	"./trea/slide2.png": "IkQc",
	"./trea/slide3.png": "IHDB",
	"./trea/slide4.png": "8ux0",
	"./trea/treaure.png": "7cnQ",
	"./year/bgi-btn-a.png": "JGdw",
	"./year/bgi-btn-i.png": "YhpC",
	"./year/bgi-btn-reg.png": "yLrB",
	"./year/bgi-form.png": "GdKx",
	"./year/bgi-input.png": "aCni",
	"./year/bgi-mobile.png": "ioh/",
	"./year/bgi-model.png": "8I8B",
	"./year/bgi-swiper.png": "4CZm",
	"./year/bgi.png": "GEbI",
	"./year/icon-close.png": "CCye",
	"./year/icon-left.png": "Wbap",
	"./year/icon-right.png": "E+R3",
	"./year/logo.png": "Eeky",
	"./year/slide1.png": "OUSe",
	"./year/slide2.png": "+gDf",
	"./year/slide3.png": "K8hi",
	"./year/slide4.png": "SDWD",
	"./year/slide5.png": "O5c6",
	"./year/slide6.png": "GV1Y",
	"./year/slide7.png": "UL19",
	"./year/slide8.png": "PR/U",
	"./year/title.png": "FM5v"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0